import { Chip } from "@mui/material";
import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { useMemo } from "react";
import { fullName } from "tng-address-collection-shared/fullName.ts";
import { ManualDispatchCardItem } from "tng-address-collection-shared/types/apiTypes.ts";
import { MemoManualDispatchActions } from "../components/ManualDispatchActions.tsx";
import { useTranslator } from "../i18n/translator.ts";
import { Meta } from "./useSignatureListColumns.ts";

export const useManualDispatchColumns = () => {
  const translator = useTranslator();
  const columnHelper = useMemo(
    () => createColumnHelper<ManualDispatchCardItem>(),
    [],
  );

  return useMemo(
    () => [
      columnHelper.accessor((row) => row.manuallySentAt !== null, {
        id: "status",
        sortDescFirst: false,
        header: () => translator("statusColumn"),
        cell: ({ getValue }) => {
          const isSent = getValue();
          return (
            <Chip
              size="small"
              color={isSent ? "success" : "default"}
              label={translator(
                isSent
                  ? "manualDispatchStatusSent"
                  : "manualDispatchStatusOpen",
              )}
            />
          );
        },
        size: 120,
        meta: {} satisfies Meta,
      }),
      columnHelper.accessor(fullName, {
        id: "name",
        header: () => translator("cardTableHeaderName"),
        size: 320,
        meta: {} satisfies Meta,
      }),
      columnHelper.accessor("projectName", {
        id: "project",
        header: () => translator("cardTableHeaderProject"),
        size: 220,
        meta: {} satisfies Meta,
      }),
      columnHelper.display({
        id: "actions",
        header: "",
        cell: ({ row }) =>
          flexRender(MemoManualDispatchActions, {
            card: row.original,
          }),
        size: 260,
        meta: { align: "right" } satisfies Meta,
      }),
    ],
    [columnHelper, translator],
  );
};
